// extracted by mini-css-extract-plugin
export default {"productGrid":"Cda-z","centerLink":"Dda-z","productSection":"Eda-z","item":"Fda-z","ctaButton":"Gda-z"};